import React from 'react';
import Layout from '../components/Layout';
import BannerSaubenoise from '../components/BannerSaubenoise';
import InfoSaubenoise from '../components/InfoSaubenoise';

const SaubenoisePage = () => {
  return (
    <div>
      <Layout 
        Banner={<BannerSaubenoise />} 
        InfoSection={<InfoSaubenoise />} 
      />
    </div>
  );
};

export default SaubenoisePage;